import { render, staticRenderFns } from "./PasswordResetModal.vue?vue&type=template&id=60f9b8b6"
import script from "./PasswordResetModal.vue?vue&type=script&lang=js"
export * from "./PasswordResetModal.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetModal.vue?vue&type=style&index=0&id=60f9b8b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports